import { sendOnlinePaymentLink } from '@/API/repositories/order';
import { markInBoundCallAsConfirmed } from '@/API/repositories/queue';
import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import { PAYMENT_METHOD } from '@/common/constants/paymentMethod';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import React from 'react';

const ConfirmInboundPayment = ({ data, setClose, setShow }) => {
	const { addMessage } = useMessageQueueContext();
	const { hasUnfilledRequest, makeRequest } = useRequestsContext();

	const handleCreatePayment = async (e) => {
		e?.preventDefault();

		const paymentLinkResponse = await makeRequest(
			sendOnlinePaymentLink.bind(null, data._id),
		);

		if (!paymentLinkResponse.data) {
			return addMessage('ERROR', 'error');
		}

		const responseMakeDecision = await makeRequest(
			markInBoundCallAsConfirmed.bind(null, data._id, PAYMENT_METHOD.ONLINE),
		);

		if (!responseMakeDecision.data) {
			return addMessage('ERROR', 'error');
		}

		addMessage('Success', 'success');

		setClose(() => null);
		setShow(() => null);
	};

	return (
		<>
			{hasUnfilledRequest() && <Loading />}
			<PopUp setShow={setClose}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						gap: '20px',
						marginBottom: '20px',
					}}
				>
					Do you want to confirm Payment Order.
				</div>
				<form
					style={{
						display: 'flex',
						justifyContent: 'center',
						gap: '20px',
						flexDirection: 'column',
					}}
					onSubmit={handleCreatePayment}
				>
					<div
						style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}
					>
						<ActionButton
							color={Colors.red}
							onClick={() => setClose(false)}
							style={{ fontSize: '14px', padding: '8px', width: '100px' }}
							text='No'
						/>
						<SubmitButton
							style={{ fontSize: '14px', padding: '8px', width: '100px' }}
							text='Yes'
							color={Colors.green}
						/>
					</div>
				</form>
			</PopUp>
		</>
	);
};

export default ConfirmInboundPayment;
